import { useLocation } from 'react-router'
import { QuoteOrderCommentsButton, QuoteOrderDownloadButtonPDF, QuoteOrderDownloadPdfTemplateButton, QuoteOrderDuplicateButton, QuoteOrderVersionsSelector } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderQuoteLayout/QuoteOrderButtons'
import { getBasePath } from '../../../../../../../../../../utils/globals/link'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { SellDownloadButtonCSV, SellPdfPreview } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellLayout/SellButtons'
import { OrderStepButtonsBase, OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import { useMemo } from 'react'
import { OrderStepButtonsDefaultBaseComponent, OrderStepButtonsNewStyleBaseComponent } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent'
import { OrderDivideIntoChaptersButton, OrderProductTypesButton } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtons'

const QuoteOrderCreateNoPermissionButtons: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, ...rest }) => {
    const location = useLocation()
    return (
        <div className='flex justify-center items-center gap-15 relative order_config_buttons flex-wrap'>
            <OrderStepButtonsDefaultBaseComponent {...{ data, onSubmit, hookFunction: useQuoteOrderCreateNoPermissionButtonsLogic, ...rest }} />
            <div className='absolute top-9 right-0 order_version_selector'>
                <QuoteOrderVersionsSelector key='previousV' url={getBasePath(location.pathname, 'single')} versions={data?.header?.versions} currentValue={data?.header?.id} />
            </div>
        </div>
    )
}

const useQuoteOrderCreateNoPermissionButtonsLogic = ({ data, onSubmit, isReadOnly }: OrderStepButtonsBaseComponentProps) => {
    const {t} = useTwinTranslation()
    const name = 'quote_order_create_no_permission_buttons'
    const Order = data?.header
    const showNoPermissionButtons = !Order?.hidePrices

    const defaultButtons = [{ "id": "previewQuote" }, { "id": "downloadQuote" }, { "id": "quoteOrderComments" }, { "id": "duplicateQuoteOrder" }]

    const quoteOrderCommentsText = t('conversationWithCustomer', 'Conversación con el cliente')
    const quoteOrderDuplicateText = t('duplicateQuote', 'Duplicar presupuesto')
    const sellDownloadCSVText = t('downloadCSV', 'Descargar CSV')
    const sellPdfPreviewText = t('previewPdf', 'Previsualizar PDF')
    const quoteOrderDownloadPdfTemplateText = t('downloadSelectingPdfTemplate', 'Descargar seleccionando plantilla PDF')
    const quoteOrderDownloadButtonPDFText = t('downloadPdf', 'Descargar PDF')
    const quoteOrderDivideIntoChaptersText = t('divideIntoChapters', 'Dividir en capítulos')
    const quoteOrderProductTypesText = t('valueProductTypes', 'Valor tipos de producto')

    const ButtonComponents: OrderStepButtonsBase = useMemo(() => {
        return {
            quoteOrderComments: {
                component: QuoteOrderCommentsButton,
                extraProps: {
                    title: quoteOrderCommentsText,
                    id: 'quoteOrderComments',
                    allRowData: data,
                    onSubmit,
                    readOnly: true
                }
            },
            duplicateQuoteOrder: {
                component: QuoteOrderDuplicateButton,
                showButton: showNoPermissionButtons,
                extraProps: {
                    id: 'duplicateQuoteOrder',
                    allRowData: data,
                    title: quoteOrderDuplicateText,
                    key:'duplicateButton'
                }
            },
            downloadQuoteCsv: {
                component: SellDownloadButtonCSV,
                showButton: showNoPermissionButtons,
                extraProps: {
                    title: sellDownloadCSVText,
                    id: 'downloadQuoteCsv',
                    Order,
                    typeTemplate: 'quoteOrder'
                }
            },
            previewQuote: {
                component: SellPdfPreview,
                showButton: showNoPermissionButtons,
                extraProps: {
                    title: sellPdfPreviewText,
                    id: 'previewQuote',
                    Order,
                    typeTemplate: 'quoteOrder'
                }
            },
            downloadQuotePDFTemplate: {
                component: QuoteOrderDownloadPdfTemplateButton,
                showButton: showNoPermissionButtons,
                extraProps: {
                    title: quoteOrderDownloadPdfTemplateText,
                    id: 'downloadQuotePDFTemplate',
                    key: 'downloadQuotePDFTemplate',
                    Order
                }
            },
            downloadQuote: {
                component: QuoteOrderDownloadButtonPDF,
                showButton: showNoPermissionButtons,
                extraProps: {
                    title: quoteOrderDownloadButtonPDFText,
                    id: 'downloadQuote',
                    Order,
                    key: 'downloadQuote'
                }
            },
            divideIntoChaptersQuote: {
                component: OrderDivideIntoChaptersButton,
                extraProps: {
                    title: quoteOrderDivideIntoChaptersText,
                    id: 'divideIntoChaptersQuote',
                    allRowData: data,
                    onSubmit,
                    isReadOnly,
                }
            },
            quoteProductTypes: {
                component: OrderProductTypesButton,
                showButton: showNoPermissionButtons,
                extraProps: {
                    title: quoteOrderProductTypesText,
                    id: 'quoteProductTypes',
                    allRowData: data,
                    onSubmit,
                    isReadOnly
                }
            },
        }
    }, [Order, data, quoteOrderCommentsText, quoteOrderDownloadButtonPDFText, quoteOrderDownloadPdfTemplateText, quoteOrderDuplicateText, sellDownloadCSVText, sellPdfPreviewText, showNoPermissionButtons, onSubmit, quoteOrderDivideIntoChaptersText, isReadOnly, quoteOrderProductTypesText])

    return { name, ButtonComponents, defaultButtons }
}

export const QuoteOrderCreateNoPermissionButtonsNew: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, ...rest }) => {
    const location = useLocation()
    return (
        <div className='flex order_config_buttons_parent justify-center items-center gap-15 relative order_config_buttons flex-wrap'>
            <OrderStepButtonsNewStyleBaseComponent {...{ data, onSubmit, hookFunction: useQuoteOrderCreateNoPermissionButtonsLogic, ...rest }} />
            <div className='absolute top-9 right-0 order_version_selector'>
                <QuoteOrderVersionsSelector key='previousV' url={getBasePath(location.pathname, 'single')} versions={data?.header?.versions} currentValue={data?.header?.id} />
            </div>
        </div>
    )
}

export default QuoteOrderCreateNoPermissionButtons